import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Cross from "../../../../assets/images/onboardingImages/crossBlack.svg";
import "./SubmittedReview.css";
import CheckImg from "../../../../assets/images/onboardingImages/check.gif";

const SubmittedReview = () => {
  const [show, setShow] = useState(true);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className="onboarding-modal-wrapper">
      <Modal
        animation={false}
        show={show}
        onHide={handleClose}
        centered
        dialogClassName="custom-onboarding-modal cmSide reviewModalSubmitted"
        backdropClassName="onboarding-custom-backdrop"
      >
        <Modal.Body className="figma-drop-shadow">
          <button type="button" className="CrossIcon" onClick={handleClose}>
            <img src={Cross} alt="Cross Image" />
          </button>
          <div className="onboardingContentBox top31px">
            <h2 className="title">
              <span>Review submitted</span>
            </h2>
            <p className="desc">
              Thank you! It means a lot to our service <br /> and for our future
              members!
            </p>
            <img src={CheckImg} className="checkImg" alt="" />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SubmittedReview;
